// extracted by mini-css-extract-plugin
export default {"homeScope":"home_homeScope__bE-B-","resourcesScope":"home_resourcesScope__+7pvI"};